/**
 * オーディエンスカテゴリー
 */
const audienceCategory = {
  1: 'RFM',
  2: 'コンバージョンイベント',
  3: 'フリークエンシー',
  4: '自社ECユーザー',
  5: '検索キーワード',
  6: 'Amazonセグメント'
}

export default audienceCategory
